import type { FunctionComponent } from 'react';

const StandardLabel: FunctionComponent = function () {
  return (
    <p>
      <span className="text-16-20-em text-neutral-900 mr-1.5 md:mr-3">
        Job Type
      </span>
      <span className="whitespace-nowrap text-style-h text-neutral-600">
        (visible only to the lender)
      </span>
    </p>
  );
};

export default StandardLabel;
